import { useTheme } from 'styled-components'
import { useMediaBreakpoints } from '@ucheba/utils/hooks/useMediaBreakpoints'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { coreSelectors } from '@ucheba/store/core'
import { IThemeVariables } from '@ucheba/utils/helpers/styles/types'

/** Динамическая ширина элемента относительно ширины окна и ширины контейнера */
export const useDynamicWidth = (): number => {
  const [currentWidth, setCurrentWidth] = useState(0)
  const theme = useTheme() as Required<IThemeVariables>
  const isTouch = useSelector(coreSelectors.isTouch)

  const desktopContainerWidth = useMediaBreakpoints(
    ['lgAndUp', 'mdAndUp'],
    [theme.container.lg, theme.container.md],
    ''
  )

  const touchContainerWidth = useMediaBreakpoints(
    ['smAndDown', 'smAndUp'],
    ['', theme.container.sm],
    ''
  )

  const resizeHandler = (event: UIEvent): void => {
    const target = event?.target as Window

    setCurrentWidth(target?.innerWidth || 0)
  }

  useEffect(() => {
    window.addEventListener('resize', resizeHandler)

    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  /** Выставляем первоначальную ширину окна при загрузке страницы */
  useEffect(() => {
    setCurrentWidth(window.innerWidth)
  }, [])

  const currentContainerWidth = useMemo(
    () => (isTouch ? touchContainerWidth : desktopContainerWidth),
    [desktopContainerWidth, isTouch, touchContainerWidth]
  )

  return useMemo(() => {
    return currentContainerWidth
      ? (currentWidth - Number(currentContainerWidth.replace('px', ''))) / 2
      : 0
  }, [currentContainerWidth, currentWidth])
}
